var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1261 7.84239H20.1351C20.1351 7.84239 14.3633 4.0085 13.571 3.48651C12.7786 2.96453 12.0042 3.00053 12.0042 3.00053C12.0042 3.00053 11.2299 2.96453 10.4375 3.48651C9.64513 4.0085 3.87341 7.84239 3.87341 7.84239H3.88242C3.36017 8.15738 3 8.72436 3 9.38134V18.0571C3 19.677 4.32362 21 5.94439 21H18.0551C19.6758 21 20.9995 19.677 20.9995 18.0571V9.38134C20.9995 8.72436 20.6393 8.15738 20.1171 7.84239H20.1261Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00537 17.3101H15.0022",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8858315e42a3d71911dde7b0eb881ba7.svg";
export { ForwardRef as ReactComponent };